var render = function render(){var _vm=this,_c=_vm._self._c;return _c("docAndService",{tag:"div",attrs:{"docInfo":_vm.serviceInfo}})
}
var staticRenderFns = []

export { render, staticRenderFns }